import { Component, computed, input, numberAttribute, ViewEncapsulation } from '@angular/core';

import { clamp } from '../util/math';
import { BspkIcon } from '../icon/icon.component';
import { BspkTxt } from '../txt';

export type ProgressStepperVariant = 'horizontal' | 'vertical';

export type ProgressStepperItem = {
  name: string;
  subtext?: string;
  touchLink?: {
    label: string;
    onClick?: () => void;
  };
};

@Component({
  selector: 'bspk-progress-stepper',
  imports: [BspkIcon, BspkTxt],
  templateUrl: './progress-stepper.component.html',
  styleUrl: './progress-stepper.component.scss',
  host: {
    'data-bspk': 'progress-stepper',
    '[attr.data-variant]': 'variant()',
  },
  encapsulation: ViewEncapsulation.None,
})
export class BspkProgressStepper {
  readonly steps = input.required<ProgressStepperItem[]>();
  readonly currentStep = input(0, { transform: numberAttribute });
  readonly variant = input<ProgressStepperVariant>('horizontal');
  protected readonly currentStepNumber = computed(() => clamp(this.currentStep(), 0, this.steps().length - 1));
}
